import { IComponentOptions, IController } from 'angular';
import { StateService, Transition } from '@uirouter/angularjs';
import { IRawRole } from '../../../../core/services/role/role.interfaces';
import { StorageService } from '../../../../core/providers/storage/storage.service';
import { EmployerRegData } from '../../models/employer-reg-data';
import { CandidateRegData } from '../../models/candidate-reg-data';
import './registration.component.scss';

class RegistrationController implements IController {
  static $inject = [
    '$state',
    '$cookies',
    'StorageService',
  ];
  $transition$: Transition;
  _selectedRole: IRawRole = {};
  selectedGroup: IRawRole = {};
  regSuccess: boolean;
  parentId: number;
  data: EmployerRegData | CandidateRegData;

  selectGroupRegistration: string;
  showBlock: boolean = true;
  arrow: boolean = false;
  registerBlock: boolean = false;
  registerAs: boolean = false;

  constructor(private $state: StateService,
    private storageService: StorageService) {
  }

  $onInit() {
    this.checkRererral();
  }

  get selectedRole() {
    return this._selectedRole;
  }

  onGroupSelect($event) {
    this.selectGroupRegistration = $event;
    this.showBlock = false;
    this.registerAs = true;
    this.arrow = true;
  }

  onRoleSelect($event: { role: IRawRole, group: IRawRole }) {
    this.selectedGroup = $event.group;
    this._selectedRole = $event.role;
    this.registerAs = false;
    this.registerBlock = true;
  }

  onRegister($event: { data: EmployerRegData | CandidateRegData }) {
    this.data = $event.data;
    this.regSuccess = true;
    this.storageService.remove('parent_id');
  }

  private checkRererral() {
    const id = this.$transition$.params().id;
    if (id) {
      this.parentId = id;
      this.storageService.put('parent_id', id);
    } else {
      this.parentId = this.storageService.get('parent_id');
    }
  }

  returnPrevPage() {
    if (this.registerBlock) {
      this.registerBlock = false;
      this.registerAs = true;
    } else if (this.registerAs) {
      this.registerAs = false;
      this.arrow = false;
      this.showBlock = true;
    }
  }

}

export const RegistrationComponent: IComponentOptions = {
  controller: RegistrationController,
  template: require('./registration.component.html'),
  bindings: {
    $transition$: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states_mobile/auth/components/registration/registration.component.ts